import * as React from 'react';

/** Stupid hack for unit tests in jsdom which doesn't yet define `DOMRect`. Replace uses with `new DOMRect()` once jsdom catches up. */
export const EmptyRect = Object.freeze<DOMRect>({
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
  toJSON: (): object => {
    const jsonRect = { ...EmptyRect };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete jsonRect.toJSON;
    return jsonRect;
  },
});

export interface SkeletonLoaderInfoContext {
  clientRect: DOMRect;
  darkMode: boolean;
  isInitialized: boolean;
}

export const SkeletonLoaderInfoContext = React.createContext<SkeletonLoaderInfoContext>({
  clientRect: EmptyRect,
  darkMode: false,
  isInitialized: false,
});
